export type URLTrackingOptionValue = "true" | "false" | "default"

export interface URLTrackingOptions {
  pers: URLTrackingOptionValue
  short: URLTrackingOptionValue
}

export interface ParsedURLTrackingOption {
  url: string
  options: URLTrackingOptions
}

const DEFAULT_OPTIONS: URLTrackingOptions = {
  pers: "default",
  short: "default",
}

const OPTION_PREFIX_PATTERN = /^\(\{([^}]*)\}\)/

function normalizeOptionValue(value?: string): URLTrackingOptionValue {
  if (value === "true" || value === "false") {
    return value
  }

  return "default"
}

export function parseURLTrackingOption(value?: string | null): ParsedURLTrackingOption {
  const rawValue = value || ""
  const matched = rawValue.match(OPTION_PREFIX_PATTERN)

  if (!matched) {
    return {
      url: rawValue,
      options: { ...DEFAULT_OPTIONS },
    }
  }

  const options = matched[1].split(",").reduce(
    (acc, item) => {
      const [rawKey, rawValue] = item.split("=")
      const key = rawKey?.trim()

      if (key === "pers" || key === "short") {
        acc[key] = normalizeOptionValue(rawValue?.trim())
      }

      return acc
    },
    { ...DEFAULT_OPTIONS }
  )

  return {
    url: rawValue.slice(matched[0].length),
    options,
  }
}

export function buildURLTrackingOption(
  url: string,
  options: URLTrackingOptions
): string {
  const normalizedOptions = {
    pers: normalizeOptionValue(options.pers),
    short: normalizeOptionValue(options.short),
  }

  if (
    normalizedOptions.pers === "default" &&
    normalizedOptions.short === "default"
  ) {
    return url || ""
  }

  return `({pers=${normalizedOptions.pers}, short=${normalizedOptions.short}})${url || ""}`
}
